const state = () => ({
    langue :null
});

export default {
    namespaced: true,
    state
};